<script>
  import { onMount } from 'svelte'
  import Header from './Header.svelte'
  import Loader from './Loader.svelte'
  import MarketSheet from './MarketSheet.svelte'
  import Inventory from './Inventory.svelte'
  import Report from './Report.svelte'

  import Api from './services/Api.js'
  import {
    sheets,
    vendors,
    currentSheet,
    squareItems,
    currentLocation,
    locations,
    marketSheetItems,
    isStaff,
    isVendor,
    isAdmin,
  } from './stores/root.js'

  const init = async () => {
    getSquareItems().then((result) => squareItems.set(result))

    const sheetData = await getAllSheets()
    sheets.set(sheetData)

    currentSheet.set(sheetData.find((sheet) => !sheet.closed) || sheetData[sheetData.length - 1])

    const vendorData = await getVendors()
    vendors.set(vendorData)

    const locationData = await getLocations()
    locations.set(locationData)
  }

  // Fetchg all Markets
  const getAllSheets = async () => {
    let result = await Api.get(`/sheets?_sort=id:ASC`)
    return result.data
  }

  // Fetch all Vendors
  const getVendors = async () => {
    let result = await Api.get(`/vendors?_sort=name:ASC`)
    return result.data
  }

  // Fetch all items from Square inventory
  const getSquareItems = async () => {
    let result = await Api.get(`/items/square/all`)
    return result.data

    // if (result.data && result.data.length == 0) {
    //   return getSquareItems()
    // } else {
    //   return result.data
    // }
  }

  // Fetch specific Sheet
  const getMarketSheet = async () => {
    const sheetData = await Api.get(
      `/sheets/${$currentSheet.id}/${$currentLocation.id}`
    )
    marketSheetItems.set(sheetData.data)
  }

  // Fetch all Locations
  const getLocations = async () => {
    let result = await Api.get(`/locations?_sort=name:ASC`)
    return result.data
  }

  onMount(async () => await init())

  $: if (
    $currentSheet &&
    $currentSheet.id &&
    $currentLocation &&
    $currentLocation.id
  ) {
    getMarketSheet()
  }
</script>

<Header />

<main class="px-0 px-sm-2 px-lg-4">
  <div class="container-fluid">
    {#if $isStaff}
      <MarketSheet />
    {:else if ($isAdmin) && $locations.length && $currentSheet && $currentSheet.closed}
      <Report />
    {:else if ($isVendor || $isAdmin) && $locations.length && $currentSheet}
      <Inventory />
    {:else}
      <Loader />
    {/if}
  </div>
</main>

<style>
  main {
    margin-bottom: 100px;
  }
</style>
